// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "心理咨询实用技术",
      "tec": "于瑶",
      "week": "1-8周",
      "add": "实训楼E座311东"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "社会工作督导与评估",
      "tec": "王艳峰",
      "week": "1-8周",
      "add": "教学楼D座225经管"
    },
    {
      "sub": "社会工作实务",
      "tec": "柳玉芬",
      "week": "1-10周",
      "add": "教学楼D座223经管"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "社会工作研究方法",
      "tec": "于瑶",
      "week": "1-10周",
      "add": "实训楼E座312西"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "社会工作实务",
      "tec": "柳玉芬",
      "week": "1-10周",
      "add": "教学楼D座223经管"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "社会工作研究方法",
      "tec": "于瑶",
      "week": "1-10周",
      "add": "实训楼E座312西"
    },
    {
      "sub": "社会工作督导与评估",
      "tec": "王艳峰",
      "week": "1-8周",
      "add": "教学楼D座225经管"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
